import { ReactElement } from "react";
import { DotLegalDialog, DotLegalPrettyScrollbar, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";

export interface IReadOnlyTableDialog<T> {
    header: string;
    headers: Array<ITableHeader<T>>;
    data: Array<T> | undefined;
    defaultOrderBy: keyof T;
    emptyText: string;
    renderRow: (row: T, index: number) => ReactElement;
    onDialogClose: () => void;
    clickableRows?: boolean;
    hover?: boolean;
}

// The read-only "linked items" list dialog shell shared by the framework control overview (anchored policies,
// linked risk assessments) and the processing activity overview (policies). Owns the dialog/scrollbar/table
// chrome; each caller supplies its own headers and renderRow so per-row concerns (permission gates, links,
// icons, badges) stay local.
export default function ReadOnlyTableDialog<T>(props: IReadOnlyTableDialog<T>) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog header={props.header} buttonOkText={""} hideOkButton open onDialogClose={() => props.onDialogClose()} onOkClick={() => {}} size={"md"}>
            <DotLegalPrettyScrollbar>
                <Box sx={{ maxHeight: 525 }}>
                    <DotLegalTable
                        hidePagination
                        emptyText={props.emptyText}
                        paginationLabelOf={translateString("labelOf")}
                        headers={props.headers}
                        defaultOrderBy={props.defaultOrderBy}
                        data={props.data}
                        defaultOrder={"asc"}
                        isLoading={false}
                        clickableRows={props.clickableRows}
                        hover={props.hover}
                        rowsPerPage={1000}
                        renderRow={props.renderRow}
                    />
                </Box>
            </DotLegalPrettyScrollbar>
        </DotLegalDialog>
    );
}
